import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import DiscountService from '../../api/services/DiscountService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import moment from 'moment';
const Discount = () => {
    const [discount, setDiscount] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = discount.slice(firstIndex, lastIndex);
    const npage = Math.ceil(discount.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getDiscount();
        }
        else {
            navigate('/')
        }
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getDiscount = async () => {
        try {
            let discount = await DiscountService.index().json();
            setDiscount(discount.data);
            setisloading(false);
        } catch (error) {
            console.log(error);
        }
    };
    const deleteDiscount = async (id) => {

        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                let responseData = await DiscountService.destroy(id).json()
                getDiscount();

                swal("Discount Delete Succesfully", {
                    icon: "success",
                });
            }
        }).catch(() => {
            swal("Your Camper Discount is safe!");
        });
    }
    return (
        <>
            <MainPagetitle mainTitle="Discount" pageTitle={'Discount'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Discount</h4>
                                        <div>
                                            <Link to={`/admin/add_discount/`} className="btn btn-primary btn-sm ms-1">+ Add Discount</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Coupon Code</th>
                                                    <th>Discount Type</th>
                                                    <th>Discount Amount</th>
                                                    <th>StartDate</th>
                                                    <th>EndDate</th>
                                                    
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><span>{index + 1}</span></td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.coupon_code}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="">
                                                                <h6>{item.discountType}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="">

                                                                <h6>{item.discount_amount}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="">

                                                                <h6>{item.start_date ? moment(item.start_date).format('DD-MM-YYYY') :"_"}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="">

                                                                <h6>{item.end_date ? moment(item.end_date).format('DD-MM-YYYY'):"_"}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/edit_discount/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Link className="btn btn-danger shadow btn-xs sharp" onClick={() => { deleteDiscount(item.id) }}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {discount.length < lastIndex ? discount.length : lastIndex}
                                                {" "}of {discount.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default Discount;